import { render, staticRenderFns } from "./MiniTabs.vue?vue&type=template&id=22fafb34&scoped=true&"
import script from "./MiniTabs.vue?vue&type=script&lang=ts&"
export * from "./MiniTabs.vue?vue&type=script&lang=ts&"
import style0 from "./MiniTabs.vue?vue&type=style&index=0&id=22fafb34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fafb34",
  null
  
)

export default component.exports